import { getCategories } from "@/api/dictionaryAPI";
import { getBlogDetail, getBlogPosts, getGalleryImages, recentBlogPosts } from "@/api/newsAndEventsAPI";
import { createSlice, createAsyncThunk, createSelector } from "@reduxjs/toolkit";
import { filter, map } from "lodash";

export const fetchGalleryImages = createAsyncThunk(
    'galleryImages/fetchGalleryImages',
    async (_, { getState }) => {
        const { galleryImages } = getState();
        if (galleryImages.list &&
            (galleryImages.list.iics_expo?.length > 0 || galleryImages.list.vietnam?.length > 0 || galleryImages.list.conference_dubai?.length > 0)) {
            return galleryImages.list;
        }
        return await getGalleryImages();
    }
);

export const fetchBlogPosts = createAsyncThunk(
    "blogs/fetchBlogPosts",
    async (reqObj) => {
        return await getBlogPosts(reqObj);
    }
)

export const fetchCategories = createAsyncThunk(
    "categories/fetchCategories",
    async (_, { getState }) => {
        const { galleryImages } = getState();
        if (galleryImages.categories &&
            (galleryImages.categories?.length > 0)) {
            return galleryImages.categories;
        }
        return await getCategories();
    }
)

export const fetchBlogDetail = createAsyncThunk(
    "blogs/fetchBlogDetail",
    async (blog_slug) => {
        return await getBlogDetail(blog_slug);
    }
);

export const fetchRecentBlogPosts = createAsyncThunk(
    "blogs/recentPosts",
    async (blog_id) => {
        return await recentBlogPosts(blog_id);
    }
)

const galleryImagesSlice = createSlice({
    name: "galleryImages",
    initialState: { list: { gulfood: [], conference: [], iics_expo: [], vietnam: [], conference_dubai: [] }, loading: false, error: null, blogs: [], categories: [], blog_detail: null, recentBlogs: [] },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchGalleryImages.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchGalleryImages.fulfilled, (state, action) => {
                state.loading = false;
                state.list = action.payload || { gulfood: [], conference: [], iics_expo: [], vietnam: [], conference_dubai: [] };
            })
            .addCase(fetchGalleryImages.rejected, (state, action) => {
                state.loading = false;
                state.error = "Something Went Wrong!";
            });
        builder
            .addCase(fetchBlogPosts.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBlogPosts.fulfilled, (state, action) => {
                state.blogs = action.payload;
                state.loading = false;
            })
            .addCase(fetchBlogPosts.rejected, (state, action) => {
                state.loading = false;
                state.blogs = [];
            });

        builder
            .addCase(fetchCategories.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCategories.fulfilled, (state, action) => {
                state.categories = action.payload;
                state.loading = false;
            })
            .addCase(fetchCategories.rejected, (state, action) => {
                state.loading = false;
                state.categories = [];
            });

        builder
            .addCase(fetchBlogDetail.pending, (state) => {
                state.loading = true;
                state.blog_detail = null;
            })
            .addCase(fetchBlogDetail.fulfilled, (state, action) => {
                state.loading = false;
                state.blog_detail = action.payload;
            })
            .addCase(fetchBlogDetail.rejected, (state) => {
                state.loading = false;
                state.blog_detail = null;
            });

        builder
            .addCase(fetchRecentBlogPosts.pending, (state) => {
                state.loading = true;
                state.recentBlogs = [];
            })
            .addCase(fetchRecentBlogPosts.fulfilled, (state, action) => {
                state.loading = false;
                state.recentBlogs = action.payload;
            })
            .addCase(fetchRecentBlogPosts.rejected, (state) => {
                state.loading = false;
                state.recentBlogs = [];
            });
    }
});

export const selectCategories = (state) => state.galleryImages.categories;

export const selectFormattedCategories = createSelector([selectCategories], (categories) => filter(map(categories, (ctgy, k) => {
    if (ctgy.blog_count > 0) {
        return {
            id: ctgy.id,
            text: ctgy.category_name,
            blog_count: ctgy.blog_count,
            ClassName: "",
        }
    }

})));

export const selectFormattedCategories2 = createSelector([selectCategories], (categories) => map(categories, (ctgy, k) => {
    return {
        id: ctgy.id,
        value: ctgy.id,
        text: ctgy.category_name,
        label: ctgy.category_name,
        blog_count: ctgy.blog_count,
    }
}));

export default galleryImagesSlice.reducer;